import { get, post } from '../../api';
import { Store } from 'react-notifications-component';
import { COMMON_DATA_UPDATE_SUCCESS, COMMON_DATA_UPDATE_FAIL } from '../../constants/notification-settings';

export const FETCH_BONUS_BALANCE_START = 'FETCH_BONUS_BALANCE_START';
export const FETCH_BONUS_BALANCE_SUCCESS = 'FETCH_BONUS_BALANCE_SUCCESS';
export const FETCH_BONUS_BALANCE_FAIL = 'FETCH_BONUS_BALANCE_FAIL';

export const FETCH_BONUS_HISTORY_START = 'FETCH_BONUS_HISTORY_START';
export const FETCH_BONUS_HISTORY_SUCCESS = 'FETCH_BONUS_HISTORY_SUCCESS';
export const FETCH_BONUS_HISTORY_FAIL = 'FETCH_BONUS_HISTORY_FAIL';

export const ADJUST_BONUS_BALANCE_START = 'ADJUST_BONUS_BALANCE_START';
export const ADJUST_BONUS_BALANCE_SUCCESS = 'ADJUST_BONUS_BALANCE_SUCCESS';
export const ADJUST_BONUS_BALANCE_FAIL = 'ADJUST_BONUS_BALANCE_FAIL';

export const CLEAR_BONUS_BALANCE = 'CLEAR_BONUS_BALANCE';

export const fetchBonusBalance = (userId) => async (dispatch) => {
  dispatch({ type: FETCH_BONUS_BALANCE_START });
  try {
    const result = await get(`/discounts/bonus-balance/${userId}`);
    dispatch({ type: FETCH_BONUS_BALANCE_SUCCESS, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_BONUS_BALANCE_FAIL, payload: e });
    return null;
  }
};

export const fetchBonusHistory = (userId, { limit, offset, ...filters }) => async (dispatch) => {
  dispatch({ type: FETCH_BONUS_HISTORY_START });
  try {
    const sp = new URLSearchParams({ limit, offset });
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        sp.set(key, value);
      }
    });
    const result = await get(`/discounts/bonus-balance/${userId}/history?${sp.toString()}`);
    dispatch({
      type: FETCH_BONUS_HISTORY_SUCCESS,
      payload: { ...result.data, append: offset > 0 },
    });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_BONUS_HISTORY_FAIL, payload: e });
    return null;
  }
};

export const clearBonusBalance = () => ({ type: CLEAR_BONUS_BALANCE });

export const adjustBonusBalance = (data, translations) => async (dispatch) => {
  dispatch({ type: ADJUST_BONUS_BALANCE_START });
  try {
    const result = await post('/discounts/bonus-balance/adjust', data);
    dispatch({ type: ADJUST_BONUS_BALANCE_SUCCESS });
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return result.data;
  } catch (e) {
    dispatch({ type: ADJUST_BONUS_BALANCE_FAIL, payload: e });
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    return false;
  }
};
